module.exports = __webpack_public_path__ + "static/media/list-alt.4e3ff328.svg";